import React from 'react';

/**
 * Testimonials grid. `sanitized` switches to the ads_safe set (no dollar
 * figures / income claims) for the /{slug}ads page.
 * Items with a video_url render a video card; placeholder URLs ("[...]") render
 * a "link coming" card until the real link is added in the CMS.
 */
export default function Testimonials({ proof, sanitized = false }) {
  if (!proof) return null;
  const items = (sanitized ? proof.ads_safe : proof.full) || [];
  if (!items.length) return null;

  return (
    <section className="band" style={{ background: 'var(--bg)' }} data-testid="testimonials">
      <div className="wrap">
        {proof.eyebrow && <p className="eyebrow">{proof.eyebrow}</p>}
        <h2 className="display">{proof.h2}</h2>
        <div className="tgrid">
          {items.map((t) => {
            const url = t.video_url || '';
            const isPlaceholder = url.startsWith('[');
            return (
              <figure className="tcard" key={t.name}>
                {url && (
                  <a className="video" href={isPlaceholder ? undefined : url} target="_blank" rel="noopener noreferrer"
                     data-slot={`video-${t.name.toLowerCase()}`}>
                    <span className="play" aria-hidden="true">▶</span>
                    <span>{isPlaceholder ? 'Video testimonial · link coming' : `Watch ${t.name}’s story`}</span>
                  </a>
                )}
                <blockquote>“{t.blurb}”</blockquote>
                <figcaption><b>{t.name}</b>{t.role && <span>{t.role}</span>}</figcaption>
              </figure>
            );
          })}
        </div>
        {proof.results_note && <p className="note">{proof.results_note}</p>}
      </div>
    </section>
  );
}
